import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Errors, SellerService, LocalService, ManagerService } from '../../core';
import { CONSTANTS } from '../../config';

@Component({
  selector: 'app-prescribed-enablements',
  templateUrl: './prescribed-enablements.component.html',
  styleUrls: ['./prescribed-enablements.component.scss']
})
export class PrescribedEnablementsComponent implements OnInit, AfterViewInit {
  errors: Errors = { errors: {} };
  userProfile: any;
  activityChallengesFlag = false;
  isSalesChallenge = false;
  isActivityChallenge = false;
  isSalesChallengeUser = false;
  isActivityChallengeUser = false;
  isChallengePreference = false;
  leaderboardChallengesFlag = false;
  showNewChallengeTab = false;
  bonusIncentives: any;
  standardIncentives: any;
  tabs: any[] = [];
  selectedTab = '';
  viewChallengeFlag = 1;
  activityChallengesSubTabs: any[] = CONSTANTS.activityChallengesSubTabs;

  get selectedChallengeTab() {
    return this.activityChallengesSubTabs.find(item => item.id === this.viewChallengeFlag) || null;
  }

  private tabInitPendingCount = 0;

  constructor(
    private sellerService: SellerService,
    private managerService: ManagerService
  ) {}

  ngOnInit() {
    const lang = localStorage.getItem('selectedLanguage');
    if (lang === 'Korean') {
      this.activityChallengesSubTabs = CONSTANTS.korean_activityChallengesSubTabs;
    }
    if (lang === 'Japanese') {
      this.activityChallengesSubTabs = CONSTANTS.japanese_activityChallengesSubTabs;
    }
    this.userProfile = LocalService.get('userProfile');
    this.tabInitPendingCount = 3;
    this.getSalesChallenges();
    this.getCompanyPreferences();
    this.getUserPreferences(6);
    this.getUserPreferences(7);
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  private onTabPrerequisiteLoaded() {
    this.tabInitPendingCount--;
    if (this.tabInitPendingCount === 0) {
      this.initializeTabs();
    }
  }

  initializeTabs() {
    this.tabs = [
      {
        id: 'sales',
        label: 'prescribedEnablement.isSalesChallenge',
        icon: null,
        isVisible: (this.isSalesChallenge && this.isSalesChallengeUser && this.isChallengePreference),
        iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
          'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>'
      },
      {
        id: 'activity',
        label: 'prescribedEnablement.resetDeals',
        icon: null,
        isVisible: (this.isActivityChallenge && this.isActivityChallengeUser),
        iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
          'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0' +
          'l-2.35 8.36A2 2 0 0 1 4.49 12H2"/></svg>'
      },
      {
        id: 'leaderboard',
        label: 'manageActivity.leaderBoardChallenge',
        icon: null,
        isVisible: (this.isActivityChallenge && this.isActivityChallengeUser),
        iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
          'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/>' +
          '<path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>' +
          '<path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>' +
          '<path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/></svg>'
      }
    ];
    const firstVisible = this.tabs.find(t => t.isVisible);
    if (firstVisible) {
      this.selectedTab = firstVisible.id;
      this.onTabChange(firstVisible.id);
    }
  }

  onTabChange(id: string) {
    this.selectedTab = id;
    if (id === 'sales') { this.resetDeals(false); }
    if (id === 'activity') { this.resetDeals(true); }
    if (id === 'leaderboard') { this.resetDeals('leaderboard'); }
  }

  getSalesChallenges() {
    const params = {
      region: this.userProfile.company.region,
      beGeoId: this.userProfile.company.beGeoId,
      page: 0,
      size: 4,
      console: localStorage.getItem('selectedRole') === 'manager' ? 'LEADER' : 'SELLER',
    };
    this.sellerService.getStandardIncentives(params).subscribe((data: any) => {
      this.standardIncentives = data;
    }, (err: any) => {
      this.errors = err;
    });
    this.sellerService.getBonusIncentives(params).subscribe((data: any) => {
      this.bonusIncentives = data;
    }, (err: any) => {
      this.errors = err;
    });
  }

  getCompanyPreferences() {
    if (this.userProfile.company && this.userProfile.company.id) {
      const companyParams = { companyId: this.userProfile.company.id };
      this.managerService.getCompanyPreferences(companyParams).subscribe((data: any) => {
        const preferences = data.companyPreferences.map((item: any) => item.enabled);
        this.isSalesChallenge = preferences[0];
        this.isActivityChallenge = preferences[1];
        if (!this.isSalesChallenge) {
          this.activityChallengesFlag = true;
        }
        const preference = data.companyPreferences.find((item: any) => item.name === 'COMPANY_SALES_CHALLENGES_AND_REWARDS');
        if (preference) {
          this.isChallengePreference = preference.enabled;
        }
        if (!this.isChallengePreference) {
          this.activityChallengesFlag = true;
        }
        this.onTabPrerequisiteLoaded();
      }, (err: any) => {
        this.errors = err;
        this.onTabPrerequisiteLoaded();
      });
    }
  }

  getUserPreferences(id: number) {
    const params = {
      userId: this.userProfile.id,
      preferenceId: id
    };
    this.managerService.getUserPreferences(params).subscribe((data: any) => {
      if (id === 6) {
        this.isSalesChallengeUser = data.enabled;
        if (!this.isSalesChallengeUser) {
          this.activityChallengesFlag = true;
        }
      }
      if (id === 7) {
        this.isActivityChallengeUser = data.enabled;
      }
      this.onTabPrerequisiteLoaded();
    }, (err: any) => {
      this.errors = err;
      this.onTabPrerequisiteLoaded();
    });
  }

  resetDeals(flag: any) {
    if (flag === 'leaderboard') {
      this.leaderboardChallengesFlag = true;
      return;
    }
    this.leaderboardChallengesFlag = false;
    this.showNewChallengeTab = false;
    if (this.activityChallengesFlag === flag) {
      return;
    }
    this.activityChallengesFlag = flag;
    this.viewChallengeFlag = 1;
    if (flag !== true) {
      this.getSalesChallenges();
    }
  }

  showActivityTab(event: any) {
    if (event.flag) {
      this.resetDeals(true);
      if (event.showSpecialTab) {
        this.resetChallenges(3);
      }
    }
  }

  resetChallenges(flag?: number) {
    const next = flag ? flag : this.viewChallengeFlag;
    this.viewChallengeFlag = next;
  }
}
